import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { BidWorksheet } from '@app/models';

export const {
  initialState: bidWorksheetInitialState,
  selectors: bidWorksheetSelectors,
  facade: BidWorksheetFacadeBase,
} = buildState(BidWorksheet);

export function bidWorksheetReducer(
  state = bidWorksheetInitialState
): IEntityState<BidWorksheet> {
  return state;
}
